import { useNavigate } from 'react-router-dom';
import { useFetchData } from '../../hooks/useFetchData';
import styles from './SeriesPage.module.css';

const SeriesPage = ({ headerText, url, language }) => {
  const navigate = useNavigate();

  const { data, dataIsLoading, dataError } = useFetchData(url);

  if (dataIsLoading) {
    return <div>Loading ...</div>;
  }

  if (dataError) {
    return <div>Error: {dataError}</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <h2>{headerText}</h2>
      </div>

      <div className={styles.serieWrapper}>
        {data.items.map((serie) => {
          return (
            <div
              key={serie.id}
              className={styles.serie}
              onClick={() => navigate(`/${language}/serie/${serie.id}`)}
            >
              <div className={styles.imageWrapper}>
                <img src={serie.thumbnail} alt={serie.title} />
                <span>{serie.title}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SeriesPage;
